import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 0.8rem;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 1.2em;
  margin-left: 0.5rem;
  margin-top: 1.3rem;
`;
